import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import linkIcon from '../../icons/figma/settings-mobile/link.svg';
import './AccountSettingsForm.css';

const AccountSettingsForm = ({ 
  accountSettings, 
  setAccountSettings, 
  ownerAccountSettings = {},
  isOwnerViewingOwnVenue = false,
  onSave, 
  onReset,
  onNotify
}) => {
  const { currentUser, userProfile } = useAuth();

  // Display owner's details - show owner's profile image only when owner is viewing their own venue
  const profileImageUrl = isOwnerViewingOwnVenue
    ? (userProfile?.profile_image || userProfile?.profile_picture_url || currentUser?.photoURL)
    : null;
  const displayName = accountSettings?.name || ownerAccountSettings?.name || '';
  const initials = displayName
    ? displayName.trim().split(/\s+/).map((p) => p[0]).slice(0, 2).join('').toUpperCase()
    : (accountSettings?.email?.[0] || ownerAccountSettings?.email?.[0] || '?').toUpperCase();
  
  const handleReset = () => {
    if (ownerAccountSettings && (ownerAccountSettings.name || ownerAccountSettings.email || ownerAccountSettings.phone)) {
      setAccountSettings({ ...ownerAccountSettings });
    }
    if (onReset) onReset();
  };
  
  return (
    <div className="settings-panel account-settings-panel">
      <div className="account-settings-header">
        <h3 className="account-settings-title">Account settings</h3>
        <div className="account-settings-actions">
          <button className="btn-secondary" onClick={handleReset}>
            Reset
          </button>
          <button className="btn-primary" onClick={onSave}>
            Save
          </button>
        </div>
      </div>
      
      <div className="account-settings-content">
        {/* Profile Image */}
        <div className="profile-image-section">
          <div className="profile-image-container">
            {profileImageUrl && (
              <img
                src={profileImageUrl}
                alt="Profile"
                className="profile-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextElementSibling?.classList.add('visible');
                }}
              />
            )}
            <span className={`profile-image-initials ${!profileImageUrl ? 'visible' : ''}`} aria-hidden={!!profileImageUrl}>
              {initials}
            </span>
            <button 
              className="profile-image-edit"
              onClick={() => {
                if (onNotify) onNotify({ type: 'success', title: 'Coming soon', message: 'Profile image upload will be available soon.' });
                else alert('Profile image upload coming soon!');
              }}
              title="Edit profile image"
            >
              <img src={linkIcon} alt="" width="11" height="11" />
            </button>
          </div>
        </div>
        
        {/* Form Fields */}
        <div className="account-form-fields">
          <div className="account-form-field">
            <label className="account-form-label">
              <span className="label-text">Name</span>
              <span className="required-asterisk">*</span>
            </label>
            <input 
              type="text" 
              className="account-form-input" 
              value={accountSettings?.name ?? ''}
              onChange={(e) => setAccountSettings({ ...accountSettings, name: e.target.value })}
              placeholder="Enter your name"
            />
          </div>
          
          <div className="account-form-row">
            <div className="account-form-field">
              <label className="account-form-label">
                <span className="label-text">Email</span>
                <span className="required-asterisk">*</span>
              </label>
              <input 
                type="email" 
                className="account-form-input" 
                value={accountSettings.email}
                onChange={(e) => setAccountSettings({ ...accountSettings, email: e.target.value })}
                placeholder="Enter your email"
              />
            </div>
            
            <div className="account-form-field">
              <label className="account-form-label">
                <span className="label-text">Phone</span>
                <span className="required-asterisk">*</span>
              </label>
              <input 
                type="tel" 
                className="account-form-input" 
                value={accountSettings?.phone ?? ''}
                onChange={(e) => setAccountSettings({ ...accountSettings, phone: e.target.value })}
                placeholder="Enter your phone number"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettingsForm;

